import { FormValueType } from '../hooks';

export const getTreeKey = ({ department }: FormValueType) => {
  if (!department) {
    return '';
  }
  return department.includes('department') ? '' : department;
};
